'use client';

import { ErrorBoundary } from '@benzinga/core-ui';

import { WatchlistInsightsSkeleton } from '../WatchlistInsightsSkeleton';
import { InsightsContent } from './InsightsContent';
import { useWatchlistInsights } from './useWatchlistInsights';

export const WatchlistInsights = () => {
  const { data, hasSymbols, isCryptoOnly, isInitialLoading, isLoadingChart, isLoadingMix, isRefreshing } =
    useWatchlistInsights();

  if (!hasSymbols) return null;

  if (isInitialLoading) {
    return (
      <ErrorBoundary name="WatchlistInsights">
        <WatchlistInsightsSkeleton />
      </ErrorBoundary>
    );
  }

  if (!data) return null;

  return (
    <ErrorBoundary name="WatchlistInsights">
      <div className={`transition-opacity duration-200 ease-out ${isRefreshing ? 'opacity-60' : 'opacity-100'}`}>
        <InsightsContent
          data={data}
          isCryptoOnly={isCryptoOnly}
          isLoadingChart={isLoadingChart}
          isLoadingMix={isLoadingMix}
        />
      </div>
    </ErrorBoundary>
  );
};

export default WatchlistInsights;
